import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../lib/api";

/**
 * CategoryBar — sticky multi-select pills + Følger/Alle toggle.
 * Toggle er plassert HELT TIL VENSTRE som en dag/natt-slider.
 */
export default function CategoryBar({ selected, onToggle, followMode, onFollowMode, searchValue, onSearch }) {
  const { t } = useTranslation();
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("/feed/categories").then((r) => setCats(r.data?.categories || [])).catch(() => {});
  }, []);

  return (
    <div className="sticky top-[calc(var(--beta-banner-h,0px)+64px)] lg:top-[calc(var(--beta-banner-h,0px)+84px)] z-30 bg-[var(--bg)]/95 backdrop-blur-sm pt-2 pb-3 -mx-1 px-1 border-b border-white/5"
      data-testid="beta-category-bar">
      {/* Søkefelt */}
      <div className="mb-2">
        <input
          type="search"
          value={searchValue}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={t("beta.search_placeholder", "Søk på brukernavn eller tag …")}
          className="input-editorial w-full font-manrope text-sm"
          data-testid="beta-search"
        />
      </div>

      {/* Rad med toggle + kategorier */}
      <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-thin">
        {/* Følger/Alle slider — HELT TIL VENSTRE */}
        <button
          onClick={() => onFollowMode(followMode === "follows" ? "all" : "follows")}
          className="shrink-0 flex items-center bg-black/40 border border-white/10 rounded-full p-0.5 min-w-[112px]"
          data-testid="beta-follow-toggle"
          aria-pressed={followMode === "all"}
        >
          <span className={`px-2.5 py-1 text-[10px] font-meta uppercase tracking-wider rounded-full transition-colors ${
            followMode === "follows"
              ? "bg-[var(--magenta)] text-white"
              : "text-[var(--cream-soft)]"
          }`}>
            {t("beta.follow_toggle_follows", "Følger")}
          </span>
          <span className={`px-2.5 py-1 text-[10px] font-meta uppercase tracking-wider rounded-full transition-colors ${
            followMode === "all"
              ? "bg-[var(--magenta)] text-white"
              : "text-[var(--cream-soft)]"
          }`}>
            {t("beta.follow_toggle_all", "Alle")}
          </span>
        </button>

        {/* Kategori-pills */}
        {cats.map((c) => {
          const active = selected.includes(c.key);
          return (
            <button
              key={c.key}
              onClick={() => onToggle(c.key)}
              data-testid={`beta-cat-${c.key}`}
              className={`shrink-0 px-3 py-1.5 text-[11px] font-meta uppercase tracking-wider rounded-full border transition-colors ${
                active
                  ? "bg-[var(--magenta)] border-[var(--magenta)] text-white"
                  : "border-white/15 text-[var(--cream-soft)] hover:border-[var(--magenta)]/60 hover:text-[var(--cream)]"
              }`}
            >
              <span className="mr-1">{c.icon}</span>
              {t(`beta.cat_${c.key}`, c.key)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
